import { combineReducers } from "redux";
import { IAppState } from "/druid/packages/Redux/reduxState";
import { WebChatReducer as AppState } from "/druid/packages/Redux/reducers/AppReducer";


export const reducers = AppState
